<section class="text-input-wrapper">
  <gc-input-field
    [label]="data.label | translate"
    [placeholder]="data.placeHolder | translate"
    [value]="inputValue"
    [renderTextArea]="data.isTextArea || !!isComment"
    [icon]="data.icon"
    (changed)="handleOnChangeInput($event)"
    (enterPressed)="data.isTextArea ? null : handleOnClickSave()"
    (iconClicked)="clickIcon.emit()"
  />
  @if (displayButtons) {
    <app-save-buttons
      [disableSaveButton]="disableSaveButton"
      (save)="handleOnClickSave()"
      (cancel)="handleOnClickCancel()"
    />
  }
  @if (!canBeMarkedNotApplicable && !isComment && !displayButtons) {
    @if (optionsButton) {
      <app-options-button [isDone]="data.isDone" [id]="data.id" />
    }
  }
</section>
